import { Tooltip } from "@mui/material"

const IconComponent = ({ icon, alt, onClick, height, className }) => {
    return (
        <Tooltip title={alt}>
            <img
                src={icon}
                alt={alt}
                onClick={onClick}
                className={`cursor_pointer ${className ? className : ""}`}
                height={height}
            />
        </Tooltip>
    )
}

export default IconComponent
